import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// import * as React from "react";
// import PropTypes from "prop-types";
// import { useTheme } from "@mui/material/styles";
// import AppBar from "@mui/material/AppBar";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
// import "./InnerTabs.css";
// import NewCard from "../components/CardsShown/view/NewCard";

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`full-width-tabpanel-${index}`}
//       aria-labelledby={`full-width-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

// function a11yProps(index) {
//   return {
//     id: `full-width-tab-${index}`,
//     "aria-controls": `full-width-tabpanel-${index}`,
//   };
// }

// export default function InnerTabs() {
//   const theme = useTheme();
//   const [value, setValue] = React.useState(0);
//   const [language, setLanguage] = React.useState("english"); // Default language is English

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const handleLanguageChange = (event) => {
//     setLanguage(event.target.value); // Change language state based on radio selection
//   };

//   // Tab labels based on selected language
//   const tabLabels =
//     language === "english"
//       ? ["New", "Under Prepration", "Under Deliver", "Reject"]
//       : ["नया", "तैयारी के तहत", "वितरण के अंतर्गत", "अस्वीकृत"];

//   return (
//     <div>
//       <div>
//         Language :
//         <input
//           type="radio"
//           name="language"
//           value="english"
//           checked={language === "english"}
//           onChange={handleLanguageChange}
//         />{" "}
//         English
//         <input
//           type="radio"
//           name="language"
//           value="hindi"
//           checked={language === "hindi"}
//           onChange={handleLanguageChange}
//         />{" "}
//         Hindi
//       </div>
//       <div
//         className="input"
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "end",
//           gap: 15,
//         }}
//       >
//         New : <input type="text" placeholder="1"></input> Under Prepration :
//         <input type="text" placeholder="0"></input> Under Deliver :{" "}
//         <input type="text" placeholder="0"></input>
//       </div>
//       <Box sx={{ bgcolor: "background.paper", width: "full", marginTop: 3 }}>
//         <AppBar position="static">
//           <Tabs
//             value={value}
//             onChange={handleChange}
//             indicatorColor="secondary"
//             textColor="inherit"
//             variant="fullWidth"
//             aria-label="full width tabs example"
//           >
//             <Tab label={tabLabels[0]} {...a11yProps(0)} />
//             <Tab label={tabLabels[1]} {...a11yProps(1)} />
//             <Tab label={tabLabels[2]} {...a11yProps(2)} />
//             <Tab label={tabLabels[3]} {...a11yProps(3)} />
//           </Tabs>
//         </AppBar>
//         <div style={{ backgroundColor: "rgb(233,236,243)", height: "80vh" }}>
//           <TabPanel value={value} index={0} dir={theme.direction}>
//             <NewCard />
//           </TabPanel>
//           <TabPanel value={value} index={1} dir={theme.direction}>
//             Item Two
//           </TabPanel>
//           <TabPanel value={value} index={2} dir={theme.direction}>
//             Item Three
//           </TabPanel>
//           <TabPanel value={value} index={3} dir={theme.direction}>
//             Item Three
//           </TabPanel>
//         </div>
//       </Box>
//     </div>
//   );
// }
